import { render, staticRenderFns } from "./fees.vue?vue&type=template&id=705fc9ea&scoped=true"
import script from "./fees.vue?vue&type=script&lang=js"
export * from "./fees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705fc9ea",
  null
  
)

export default component.exports